import React from "react";
import { useTranslation } from "react-i18next";
import { useSettings } from "@/contexts/SettingsContext";
import { Accessibility, Snowflake, Sun, Flame, Wifi } from "lucide-react";

const ICONS = {
  wheelchair_accessible: Accessibility,
  air_conditioning: Snowflake,
  outdoor_seating: Sun,
  heated_terrace: Flame,
  wifi: Wifi,
};

export default function Amenities({ compact = false }) {
  const { t } = useTranslation();
  const { settings: s } = useSettings();
  if (!s?.amenities) return null;
  const active = Object.entries(s.amenities).filter(([, v]) => v).map(([k]) => k);
  if (!active.length) return null;

  return (
    <div data-testid="amenities-block" className={compact ? "" : "py-8"}>
      {!compact && (
        <>
          <div className="overline">{t("amenities.overline")}</div>
          <h3 className="font-serif-luxe text-3xl text-[#F8F5EF] mt-2 mb-8">{t("amenities.title")}</h3>
        </>
      )}
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3" data-testid="amenities-list">
        {active.map(k => {
          const Icon = ICONS[k] || Sun;
          return (
            <li key={k} data-testid={`amenity-${k}`} className="luxe-card flex items-center gap-3 px-4 py-4">
              <Icon size={18} className="text-[#D4AF37] shrink-0" />
              <span className="text-sm text-[#F8F5EF]/85 leading-tight">{t(`amenities.${k}`)}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
